import { httpClient } from "../httpClient";

export async function getApproverDistro(): Promise<any> {
  try {
    const { data } = await httpClient.get(`/api/v1/approverdistro`);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const approver = {
  getApproverDistro,
};
